import { IMortalityRecipient } from "@nkr/models/index";

interface IProps {
    index: number,
    data: IMortalityRecipient
}

const Row = (props: IProps) => {
    return (
        <tr>
            <td>{props.index}</td>
            <td>{props.data.type}</td>
            <td><a href={`/center/${props.data.centerId}/recipient/${props.data.id}/profile/general`}>{props.data.alias}</a></td>
            <td>{props.data.bloodType}</td>
            <td>{props.data.age}</td>
            <td>{props.data.roundedCpra4}</td>
            <td>{props.data.applicableWaitTime}</td>
            <td>{props.data.forecastedWaitTime}</td>
            <td>{props.data.dialysisMonths}</td>
            <td>{props.data.oneYearMortalityRisk}</td>
            <td>{props.data.highestDeclineRatio}</td>
            <td><a href={`/center/${props.data.centerId}/recipient/${props.data.id}/potential-donors`}>{props.data.reviewableDonors}</a></td>
        </tr>
    )
}

export default Row;